import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-account-eve2-consent',
  templateUrl: './account-eve2-consent.component.html',
  styleUrls: ['./account-eve2-consent.component.scss'],
  standalone: false
})
export class AccountEve2ConsentComponent {
  private fb = inject(FormBuilder);
  @Input() loading = false;
  @Input() webApp = false;
  @Output() optIn: EventEmitter<void> = new EventEmitter<void>();
  @Output() downloadDoc: EventEmitter<void> = new EventEmitter<void>();
  @Output() reviewLater: EventEmitter<void> = new EventEmitter<void>();
  get acceptControl(): AbstractControl {
    return this.form.get('accept');
  }

  form = this.fb.group({
    accept: [false, [Validators.required, Validators.requiredTrue]]
  });

  onToggleConsent() {
    this.acceptControl.setValue(!this.acceptControl.value);
    this.acceptControl.updateValueAndValidity();
  }

  onDocumentDownload() {
    this.downloadDoc.emit();
  }

  onSubmit() {
    if (this.acceptControl.invalid) return;
    this.optIn.emit();
  }

  onReviewLater() {
    this.reviewLater.emit();
  }
}
